var map = {
  "./pt.po": [
    "./src/locales/pt.po",
    [
      "src_locales_pt_po"
    ]
  ],
  "./es.po": [
    "./src/locales/es.po",
    [
      "src_locales_es_po"
    ]
  ],
  "./en.po": [
    "./src/locales/en.po",
    [
      "src_locales_en_po"
    ]
  ],
  "./da.po": [
    "./src/locales/da.po",
    [
      "src_locales_da_po"
    ]
  ],
  "./fr.po": [
    "./src/locales/fr.po",
    [
      "src_locales_fr_po"
    ]
  ],
  "./it.po": [
    "./src/locales/it.po",
    [
      "src_locales_it_po"
    ]
  ],
  "./de.po": [
    "./src/locales/de.po",
    [
      "src_locales_de_po"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "./src/locales lazy recursive ^\\.\\/.*\\.po$ referencedExports: messages";
module.exports = __rspack_async_context;
